import { Stack, YStack, isWeb } from '@mythical/ui'
import { ButtonLink } from 'app/components/primitive/Button'
import { IconExternalLink } from 'app/components/primitive/Icon'
import Section, { SectionWrapperProps } from 'app/components/structure/Section'
import { SolitoImage } from 'solito/image'
import { LinkCore } from 'solito/link'

// Web hover styles
const webStyles = (
  <style jsx global>{`
    .AdFullWidth:hover .AdFullWidth__Container,
    .AdFullWidth:focus .AdFullWidth__Container,
    .AdFullWidth:active .AdFullWidth__Container {
      opacity: 1;
    }

    .AdFullWidth__Container {
      opacity: 0;
      transition: opacity 0.25s ease-in-out;
    }
  `}</style>
)

export interface AdFullWidthProps extends SectionWrapperProps {
  image: string
  ctaLabel: string
  href: string
}

export const AdFullWidth = (props: AdFullWidthProps) => {
  const { image, ctaLabel, href, ...sectionProps } = props
  return (
    <Section {...sectionProps}>
      <YStack
        className="AdFullWidth"
        pos="relative"
        jc="center"
        ai="center"
        width="100%"
        gap="$3"
        bg="$bgPrimary"
        br={6}
        overflow="hidden"
      >
        {isWeb && webStyles}
        <LinkCore
          href={href}
          Component={Stack}
          componentProps={{
            tag: 'a',
            w: '100%',
            aspectRatio: 34 / 11,
            ...(href?.startsWith('http') ? { target: '_blank' } : {}),
          }}
        >
          <SolitoImage src={image} fill alt="" contentFit="cover" />
        </LinkCore>
        {isWeb && ctaLabel && (
          <Stack
            className="AdFullWidth__Container"
            jc="center"
            ai="center"
            w="100%"
            {...(isWeb && {
              pointerEvents: 'none',
              bg: '$backdrop',
              pos: 'absolute',
              h: '100%',
            })}
          >
            <ButtonLink
              pointerEvents="auto"
              href={href}
              size="$4.5"
              textProps={{
                ff: '$title',
                fontWeight: '500',
              }}
              {...(href?.startsWith('http') ? { target: '_blank' } : {})}
            >
              {ctaLabel}
            </ButtonLink>
          </Stack>
        )}

        {!isWeb && href && (
          <ButtonLink
            bg="$bgSecondary"
            borderWidth={0}
            height={40}
            hoverStyle={{ opacity: 0.9 }}
            href={href}
            pos="absolute"
            pressStyle={{ opacity: 0.8 }}
            r={16}
            b={16}
            w={40}
            {...(href?.startsWith('http') ? { target: '_blank' } : {})}
          >
            <IconExternalLink size={16} color="$fgPrimary" />
          </ButtonLink>
        )}
      </YStack>
    </Section>
  )
}
